import React, { PropTypes, Component } from 'react';
import DragLayer from 'react-dnd/lib/DragLayer';
import { Units, Colors } from 'Css';
import { pageModules } from 'Constants';
import * as Icons from 'components/Icons';

const css = oxygenCss({
  preview: {
    opacity: 0.8,
    top: 0,
    left: 0,
    position: 'absolute',
    backgroundColor: '#d7f6f7',
    border: `solid 2px ${Colors.creen}`,
    color: Colors.creen,
    textAlign: 'center',
    lineHeight: `${Units.keyline}px`,
    height: Units.keyline,
    boxSizing: 'border-box',
    display: 'block',
    width: `${Units.keyline * 1.5}px`,
    '>SVG': {
      verticalAlign: 'middle'
    }
  }
});

const styles = {
  icon: {
    width: Units.base * 4,
    height: Units.base * 4
  }
};

function collect(monitor) {
  const item = monitor.getItem();
  const initial = monitor.getInitialClientOffset();
  const difference = monitor.getDifferenceFromInitialOffset();
  return {
    id: item && item.id,
    type: item && item.type,
    initialClientOffset:
      initial && difference
        ? {
            x: initial.x + difference.x,
            y: initial.y + difference.y
          }
        : null,
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

function getItemStyles(currentOffset) {
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }
  const { x, y } = currentOffset;
  const transform = `translate(${x - 48}px, ${y - 96}px)`;

  return {
    pointerEvents: 'none',
    transform,
    WebkitTransform: transform
  };
}

class Preview extends Component {
  static propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.object,
    currentOffset: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    }),
    initialClientOffset: PropTypes.shape({
      x: PropTypes.number,
      y: PropTypes.number
    }),
    isDragging: PropTypes.bool
  };

  render() {
    const { isDragging, type } = this.props;
    if (!isDragging) {
      return <div />;
    }
    const Icon = Icons[pageModules[type.name].icon];
    return (
      <div
        className={css.preview}
        style={getItemStyles(this.props.initialClientOffset)}
      >
        <Icon style={styles.icon} className={css.icon} color={'#777777'} />
      </div>
    );
  }
}

export default DragLayer(collect)(Preview);



// WEBPACK FOOTER //
// ./src/js/components/Page/LayoutOverview/PageLayoutOverviewColumnPreview.js